<template>
  <div class="wrapper">
    <el-dialog
        :title="rowId ? '编辑用户' : '新增用户'"
        :visible.sync="showAddOrEdit"
        width="600px"
        :before-close="cancelFun"
    >
      <el-form ref="form" :model="formData" label-width="100px">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item prop="userName" label="用户名" :rules="rules">
              <el-input size="small" v-model="formData.userName" placeholder="姓名"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="手机号" prop="mobile" :rules="rules">
              <el-input size="small" width="400px" v-model="formData.mobile" placeholder="手机号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="性别" prop="gender" :rules="rules">
              <SelectDict width="100%" v-model="formData.gender" dictCode="user:gender" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="roleId" label="角色" :rules="rules">
              <SelectRole style="width:100%" v-model="formData.roleId"></SelectRole>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="部门" prop="deptId" :rules="rules">
              <SelectDept style="width:100%" v-model="formData.deptId"></SelectDept>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
      <el-button type="info" size="small" @click="cancelFun">取 消</el-button>
      <el-button type="primary" size="small" @click="submitFun">保 存</el-button>
    </span>
    </el-dialog>
  </div>
</template>

<script>
import SelectRole from '@/views/components/select-role.vue';
import SelectDept from '@/views/components/select-dept.vue';
import SelectDict from '@/views/components/select-dict.vue';
import { addAdmin, editAdmin, getAdminDetail, getRoleList } from './api';

export default {
  name: 'Detail',
  components: { SelectRole, SelectDept, SelectDict },
  props: {
    showAddOrEdit: {
      type: Boolean,
      default: false,
    },
    rowId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      formData: {
        userName: '',
        mobile: '',
        roleId: null,
        gender: null,
        deptId: null,
        jobId: null
      },
      rules: [{ required: true, message: '该项不能为空', trigger: 'blur' }],
      roleList: [],
      roleProps: {
        children: 'children',
        label: 'name',
        value: 'id',
        emitPath: false,
        multiple: true
      },
      genderList: []
    }
  },

  mounted() {
    this.getRoleList()
    this.getDictEnumList()
    if (this.rowId) this.getAdminDetail()
  },

  methods: {
    submitFun() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          // 编辑
          await (this.rowId ? editAdmin : addAdmin)(this.formData).then(() => {
            this.$message.success(this.rowId ? '编辑成功' : '新增成功')
            this.$emit("closeDialog",true);
          })
        } else {
          return false;
        }
      })
    },
    async getAdminDetail() {
      this.formData = await getAdminDetail({ id: this.rowId })
      this.formData.gender = this.formData.gender.toString()
    },
    cancel() {
      this.$router.back(-1)
    },
    async getRoleList() {
      const res = await getRoleList({ pageSize: 50, page: 1 })
      this.roleList = res.list || []
    },
    async getDictEnumList() {
      this.genderList = await getDictEnumListAPI('gender')
    },
    cancelFun() {
      this.$emit("closeDialog");
    },
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  .el-form /deep/ {
    .el-form-item {
      .el-form-item__content {
        width: 70%;
        .el-select {
          width: 100%;
        }
      }
    }
  }
}
</style>
